import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { maybeFillArrayFiled, maybeFillField } from '@/utils/lang';
import { inject, injectable } from 'inversify';
import { omitBy, isNil, join } from 'lodash';
import { splitAccountGroup } from '@/utils/emails';
let ExportService = class ExportService {
    constructor(exportApi, BoHelperService) {
        this.exportApi = exportApi;
        this.BoHelperService = BoHelperService;
    }
    getAccountsBehaviorRecords(params, queries) {
        const { company_name, company_name_with_remark, emails, product_ids, account_id, account_type, account_status, package_ids, company_id, mobile_number, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sEcho, iDisplayLength, iDisplayStart, s_identifiers, ...OtherData } = queries;
        let paramsSend = {
            s_name_company: company_name || company_name_with_remark,
            s_email: emails,
            s_mobile_number: mobile_number,
            s_account_type: account_type,
            s_account_status: account_status,
            s_product_ids: '',
            s_account_id: account_id,
            s_package_ids: '',
            s_company_id: company_id,
            ...OtherData,
        };
        maybeFillArrayFiled(product_ids, item => { paramsSend.s_product_ids = item; });
        maybeFillArrayFiled(package_ids, item => { paramsSend.s_package_ids = item; });
        maybeFillField(s_identifiers, item => { paramsSend.s_identifiers = join(splitAccountGroup(item), ','); });
        paramsSend = omitBy(paramsSend, (value) => isNil(value) || value === '');
        return this.exportApi.getExportUsers({ ...params, ...paramsSend });
    }
    getExportCompanies(params) {
        return this.exportApi.getExportCompanies(params);
    }
};
ExportService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ExportApi)),
    __param(1, inject(Symbols.BoHelperService)),
    __metadata("design:paramtypes", [Object, Object])
], ExportService);
export { ExportService };
